
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-inkind-works",
      function () {
        return require("private-next-pages/how-inkind-works.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-inkind-works"])
      });
    }
  